import { getJson, postForm } from '../../../shared/api/httpClient';

function extractDocs(jsonResponse) {
  if (jsonResponse.data && jsonResponse.data.docs) {
    return jsonResponse.data.docs;
  }

  return jsonResponse.data || [];
}

export async function fetchBookings({ page, userAccessToken, deviceAccessToken }) {
  const jsonResponse = await getJson('GetMarivalBookings', {
    page,
    UserAccessToken: userAccessToken,
    DeviceAccessToken: deviceAccessToken,
    RegisterType: 'Agent'
  });

  const pagination = jsonResponse.pagination || {};
  const perPage = parseInt(pagination.per_page, 10) || 0;
  const currentPage = parseInt(pagination.page, 10) || page;

  let bookings = [];

  if (Array.isArray(jsonResponse.data)) {
    bookings = jsonResponse.data;
  } else if (jsonResponse.data && Array.isArray(jsonResponse.data.docs)) {
    bookings = jsonResponse.data.docs;
  }

  if (perPage > 0 && bookings.length > perPage) {
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    bookings = startIndex < bookings.length ? bookings.slice(startIndex, endIndex) : bookings.slice(-perPage);
  }

  return {
    bookings,
    pointsAvailable: jsonResponse.PointsAvailable,
    pointsPending: jsonResponse.PointsPending,
    pagination: pagination.page ? pagination : {
      page: currentPage,
      per_page: 0,
      results_in_page: bookings.length,
      total_results: bookings.length,
      total_pages: 1
    }
  };
}

export async function fetchRedemptionHistory({ userAccessToken, deviceAccessToken }) {
  const jsonResponse = await getJson('GetMarivalRedemtionHistory', {
    UserAccessToken: userAccessToken,
    DeviceAccessToken: deviceAccessToken,
    RegisterType: 'Agent'
  });

  return extractDocs(jsonResponse);
}

export async function fetchRewardTypes({ userAccessToken, deviceAccessToken }) {
  const jsonResponse = await getJson('GetMarivalRewardsTypes', {
    UserAccessToken: userAccessToken,
    DeviceAccessToken: deviceAccessToken,
    RegisterType: 'Agent'
  });

  return extractDocs(jsonResponse);
}

export function submitRedeemAwards(payload) {
  return postForm('MarivalRedeemAwards', payload);
}

export function submitRedeemAward2(payload) {
  return postForm('MarivalRedeemAwards2', payload);
}
